exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\r\n\r\nbody,html,app{\r\n    height:100%;\r\n    padding:0;\r\n    margin:0;\r\n    overflow:hidden;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/git/flowdesigner/~/css-loader?{"sourceMap":false,"importLoaders":1}!C:/git/flowdesigner/~/postcss-loader?{"ident":"postcss"}!C:/git/flowdesigner/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = 2